<div class="options-list flex-column options-list">
  <ng-content />
  <hr class="mt-4 mb-4" />

  <div class="d-flex flex-column options-list-wrapper">
    @for (option of options; track option) {
      <div class="d-flex options-list-item {{ option.state }}">
        <div class="mr-2 d-flex align-items-center justify-content-center options-list-item-icon">
          @switch (option.state) {
            @case (optionsListState.Completed) {
              <img src="assets/icons/check_green.svg" alt="check" />
            }
            @case (optionsListState.Warning) {
              <img src="assets/icons/close_red.svg" alt="close" />
            }
            @default {
              <img src="assets/icons/check_blue.svg" alt="check" />
            }
          }
        </div>
        <div>
          <p class="mb-1 options-list-item-title">{{ option.title }}</p>
          <p [innerHTML]="option.subtitle" class="caption"></p>
        </div>
      </div>
    }
  </div>
</div>
